const { captureLandingContext } = require("./src/utils/signupContext");

// Runs once per browser session, before React renders anything. This is the
// only moment where the acquisition context is still intact: the /get/:slug
// shim redirects to /{market}/get/:slug without the query string, and the
// BankID app-switch later rebuilds the page URL from protocol+host+pathname.
exports.onClientEntry = () => {
  captureLandingContext();
};
